<template>
  <div>
    <h4>Cartão de Crédito</h4>
    <div class="mt-2 mb-4">
      Nós não armazenamos os dados do seu cartão em nosso sistema.
    </div>

    <CreditCardCustomerFields :basket="basket" />

    <div class="mb-2 mt-6">
      <strong>Dados do Cartão</strong>
    </div>
    <div class="mb-2">
      <vs-input
        class="w-full"
        label="Número do Cartão"
        placeholder="Somente números"
        v-model="basket.card_number"
        v-facade="['#### #### #### ####']"
        tabindex="1"
        required
      />
    </div>
    <div class="mb-2">
      <div class="flex">
        <div class="w-6/12 mr-4">
          <vs-input
            class="w-full"
            label="Data de Validade (Mês/Ano)"
            placeholder="Somente números (MM/AA)"
            v-model="basket.card_date"
            tabindex="1"
            autocomplete="cc-exp-month"
            v-facade="'##/##'"
            required
          />
        </div>
        <div class="w-6/12">
          <vs-input
            class="w-full"
            label="Código de Segurança (CVV)"
            placeholder="Somente números"
            maxlength="4"
            v-model="basket.card_cvv"
            tabindex="1"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="cc-csc"
            v-facade="['###', '####']"
            required
          />
        </div>
      </div>
    </div>
    <div class="mb-2">
      <vs-input
        class="w-full"
        label="Nome que aparece no cartão"
        placeholder="Exatamente como está no cartão"
        v-model="basket.card_name"
        tabindex="1"
        required
      />
    </div>

    <vs-button type="relief" class="w-full mt-6" @click="next()" :disabled="basket.processing">Continuar</vs-button>
  </div>
</template>

<script>
import CreditCardCustomerFields from '../CreditCardCustomerFields.vue';
import { facade } from 'vue-input-facade';

export default {
  components: {
    CreditCardCustomerFields
  },
  directives: { facade },
  props: {
    showSubtitle: {
      type: Boolean,
      required: false,
      default: () => true
    },
    checkoutWizard: {
      type: Object,
      required: false
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  methods: {
    next() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/create', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          if (response.data && parseInt(response.data.orderId) > 0) {
            window.location.href =
              '/checkout/complete?orderId=' + response.data.orderId + '&orderNumber=' + response.data.orderNumber;
          } else {
            this.$vs.notify({
              time: 6000,
              text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
            this.basket.processing = false;
          }
        })
        .catch(error => {
          this.basket.processing = false;
          this.$EventBus.$emit('paymentProviderFailed', this.paymentMethod);

          let errors = [];
          if (error.response && error.response.data.message) {
            errors.push(error.response.data.message);
          } else if (error.response) {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                errors.push(error.response.data[key]);
              }
            }
          }

          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
